import { RouteComponentProps, withRouter } from "react-router-dom";
import { EntityType } from "../../../entities/common"
import * as ProjectsListStore from "../../../store/ProjectsListStore"
import { ApplicationState } from "../../../store";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import React from "react";
import { UserState } from "../../../store/User";
import { Subscription } from "../../../store/Tenant";
import { get } from "../../../fetch-interceptor";
import PresentationModeContainer from "./PresentationModeContainer";
import { defaultCatch } from "../../../store/utils";

type StateProps = {
    user: UserState;
    subscription: Subscription;
    url?: string;
}

export type ActionProps = {
    projectsActions: typeof ProjectsListStore.actionCreators;
    defaultCatch: (error: any) => void;
};

type Props = StateProps & ActionProps & RouteComponentProps<{ id: string }>;

const ProjPresentationMode = PresentationModeContainer<ProjectsListStore.ProjectInfo>();

const ProjectPresentationMode = (props: React.PropsWithChildren<Props>) => {
    const [entity, setEntity] = React.useState<ProjectsListStore.ProjectInfo | undefined>();
    const [isLoading, setIsLoading] = React.useState<boolean>(false);
    const { url, user, subscription, children } = props;

    React.useEffect(() => {
        setIsLoading(true);
        get<ProjectsListStore.ProjectInfo>(`/api/${EntityType.Project}/${props.match.params.id}`)
            .then(_ => {
                setEntity(_);
                props.projectsActions.setActiveProject(_);
            })
            .catch(props.defaultCatch)
            .finally(() => setIsLoading(false));
    }, []);

    return <ProjPresentationMode
        user={user}
        subscription={subscription}
        entityType={EntityType.Project}
        entity={entity}
        isLoading={isLoading}
        isViewable={entity && !entity.isArchived && !entity.isPrivate}
        url={url}>
            {children} 
    </ProjPresentationMode>
}

function mapStateToProps(state: ApplicationState, ownProps: RouteComponentProps<{ id: string }>): StateProps {
    return {
        url: state.tenant.presentationModeSettings!.project,
        user: state.user,
        subscription: state.tenant.subscription,
    };
}
 
function mergeActionCreators(dispatch: any): ActionProps {
    return {
        projectsActions: bindActionCreators(ProjectsListStore.actionCreators, dispatch),
        defaultCatch: defaultCatch(dispatch)
    }
}

export default withRouter<React.PropsWithChildren<{}>>(connect(mapStateToProps, mergeActionCreators)(ProjectPresentationMode))